/**
 * Race results. Personal bests are flagged automatically — the committee
 * never has to work out whether a time is someone's best.
 */

import { useNavigate } from 'react-router-dom';
import { formatDate, formatTime, isPersonalBest } from '../../data';
import { useClubData } from '../../context/ClubContext';
import { useUI } from '../../context/UIContext';
import { ResultSheet } from '../../components/sheets/ClubSheets';
import { Button, ButtonRow, Empty, Table, ViewTitle } from '../../components/ui';

export function ResultsPage() {
  const { db } = useClubData();
  const { openSheet } = useUI();
  const navigate = useNavigate();

  const all = [...db.results].sort((a, b) => b.date.localeCompare(a.date));

  return (
    <>
      <ViewTitle
        title="Race results"
        sub={`${all.length} logged · personal bests flagged automatically`}
      />

      <div className="mb-[18px]">
        <ButtonRow>
          <Button tone="d" onClick={() => openSheet(<ResultSheet db={db} />)}>
            + Log a race result
          </Button>
        </ButtonRow>
      </div>

      {all.length ? (
        <Table
          head={
            <tr>
              <th>Date</th>
              <th>Member</th>
              <th>Race</th>
              <th>Dist</th>
              <th>Time</th>
            </tr>
          }
        >
          {all.map((r) => {
            const member = db.members.find((m) => m.id === r.memberId);
            if (!member) return null;
            const pb = isPersonalBest(db.results, member.id, r.dist, r.timeS, r.id);

            return (
              <tr
                key={r.id}
                className="cursor-pointer hover:bg-ground-warm"
                onClick={() => {
                  navigate(`/a/members/${member.id}`);
                  window.scrollTo(0, 0);
                }}
              >
                <td className="sm:whitespace-nowrap">{formatDate(r.date)}</td>
                <td className="font-market font-bold text-ink-700">{member.name}</td>
                <td>{r.race}</td>
                <td>{r.dist}</td>
                <td className="sm:whitespace-nowrap">
                  {/* one element, so the phone layout keeps the badge beside
                      the time rather than treating it as a second value */}
                  <span>
                    {formatTime(r.timeS)}
                    {pb && (
                      <span className="ml-1.5 rounded bg-gold-500 px-1.5 py-px align-[2px] font-market text-[8px] text-ink-800">
                        PB
                      </span>
                    )}
                  </span>
                </td>
              </tr>
            );
          })}
        </Table>
      ) : (
        <Empty title="No results yet">Log a race to begin.</Empty>
      )}
    </>
  );
}
